import { createAction, props } from '@ngrx/store';
import {StreamConfiguration} from '../../../services/api/stream-configurations/stream-configuration.model';
import {UUID} from '../../../shared/types/uuid.type';

const prefix = '[StreamConfigurations]';

export const loadStreamConfigurations = createAction(
  `${prefix} Load Stream Configurations`
);

export const loadStreamConfigurationsSuccess = createAction(
  `${prefix} Load Stream Configurations Success`,
  props<{ data: StreamConfiguration[]}>()
);

export const loadStreamConfigurationsFailure = createAction(
  `${prefix} Load Stream Configurations Failure`,
  props<{ error: unknown }>()
);

export const manyStreamConfigurationsDeleted = createAction(
  `${prefix} Many Stream Configurations Deleted`,
  props<{ ids: UUID[] }>()
);

export const clearStreamConfigurationsState = createAction(
  `${prefix} Clear Stream Configurations State`,
);
